module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAMAAABhEH5lAAAAAXNSR0IArs4c6QAAAIdQTFRFAAAA/98A/+oA/98L/+UN+eYN/+cM+eIM/+kL+uQL++cM/+gL/+cO/OQN/+YM/OQM/OYO/+cN/+cO/eUP/+cN/+YO/+cO/+YN/eUO/eYO/+YO/+cO/uYN/uYP/uYP/uYO/ucO/uYO/uYP/uYP/uYO/ucO/uYP/uUP/uYP/uUO/uYO/uYO/uYPJilcCQAAACx0Uk5TAAgMGCcoKywvMEBDS0xTVFxff4uLj5Obn6Ojp6uvv8PHy8/T19vf7/P39/t9m21vAAAAdklEQVQYGV3BixKBQACG0c/mrtwToRRp8b//82mamHbPoRWenq/6vpvyMy7UORpaC6u/R0BjaNVTDIBcji2EctWGRJ4llTwxVp4zVp4rlTwHEnnWRHLVBjI5SmBk5QiAuVXfhsbkps4l+yilFaXV25bxDMxq/wWHUyvURg2rogAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/imgs/hafa.png
// module id = OTmY
// module chunks = 0